'use client';

import { NewsCategory } from '@fe-news/constants/categories';
import { getCategoryFromPathname } from '@fe-news/utils/category';
import { usePathname } from 'next/navigation';
import { Suspense, memo } from 'react';
import { HeadlineAdProfiles } from '@fe-news/constants/DFP';
import { DisplayOnMountedAdSlot } from '@fe-news/components/atoms/AdSlot';

const CRYPTOS = new Set([
  NewsCategory.BC_CRYPTO,
  NewsCategory.BC_LIVE,
  NewsCategory.BC_NEWS,
  NewsCategory.BC_TUTORIAL,
  NewsCategory.CRYPTO
]);

const AsideDesktopFirstAd = () => {
  const pathname = usePathname();
  const category = getCategoryFromPathname(pathname);

  // 虛擬貨幣分類需要顯示另一種廣告
  return (
    <Suspense>
      {CRYPTOS.has(category) ? (
        <DisplayOnMountedAdSlot profile={HeadlineAdProfiles.loadOnMounted.desktop.asideCryptoBannerTop} />
      ) : (
        <DisplayOnMountedAdSlot profile={HeadlineAdProfiles.loadOnMounted.desktop.AsideBannerTop} />
      )}
    </Suspense>
  );
};

export default memo(AsideDesktopFirstAd);
